import React from "react";
import { OWGameResponse } from "@devour/client";
import { FaSteam, FaUsers, FaChartLine, FaGamepad } from "react-icons/fa";

interface GameSteamStatsSectionProps {
    game: OWGameResponse & { currentPlayers?: number };
}

const GameSteamStatsSection: React.FC<GameSteamStatsSectionProps> = ({ game }) => {
    // Format numbers for display
    const formatNumber = (num: number | undefined | null) => {
        if (num === null || num === undefined) return "N/A";
        if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
        if (num >= 1000) return `${(num / 1000).toFixed(0)}K`;
        return num.toLocaleString();
    };

    // DO NOT CREATE FAKE DATA - removed fake percentage calculation

    return (
        <div className="game-steam-stats">
            <div className="game-steam-stats__header">
                <h3><FaSteam className="game-steam-stats__header-icon" /> {game.name}</h3>
            </div>

            <div className="game-steam-stats__grid">
                {game.steamAppId &&
                    <div className="game-steam-stats__stat">
                        <FaSteam className="game-steam-stats__icon" />
                        <div className="game-steam-stats__info">
                            <span className="game-steam-stats__value">{game.steamAppId}</span>
                            <a
                                href={`https://store.steampowered.com/app/${game.steamAppId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="game-steam-stats__link"
                                style={{ textDecoration: "none", color: "inherit" }}
                            >
                                <span className="game-steam-stats__label">View →</span>
                            </a>
                        </div>
                    </div>
                }

                {/* Current Players Online - replaces Achievements */}
                <div className="game-steam-stats__stat">
                    <FaGamepad className="game-steam-stats__icon" />
                    <div className="game-steam-stats__info">
                        <span className="game-steam-stats__value">
                            {formatNumber(game.currentPlayers)}
                        </span>
                        <span className="game-steam-stats__label">Playing Now</span>
                    </div>
                </div>

                {/* REMOVED FAKE DATA - No percentage or recommendations displayed until real data available */}
            </div>

            {(game as any).steamData?.website &&
                <div className="game-steam-stats__update">
                    <a href={(game as any).steamData.website} target="_blank" rel="noopener noreferrer"
                        className="game-steam-stats__website-link">
                        Visit {game.name} Website →
                    </a>
                </div>
            }
        </div>
    );
};

export default GameSteamStatsSection;